export const getErrorMessage = (field, value, refinancingData, setIsDragging) => {
    if (!refinancingData) {
        setIsDragging(false);
        return { message: '' };
    }
    const errorMessages = {
        loanAmount: 'Beløpet er for lavt eller høyt',
        interestRate: 'Renten er for lav eller høy',
        termYears: 'Nedbetalingstid er for lang',
    };
    const validations = {
        loanAmount: {
            min: refinancingData.minPrincipal,
            max: refinancingData.maxPrincipal,
        },
        interestRate: {
            min: refinancingData.minInterestRate,
            max: refinancingData.maxInterestRate,
        },
        termYears: {
            min: refinancingData.minDurationInYears,
            max: refinancingData.maxDurationInYears,
        },
    };
    const { min, max } = validations[field];
    const message = errorMessages[field];
    if (value < min || value > max) {
        setIsDragging(true);
        return { message };
    }
    setIsDragging(false);
    return { message: '' };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy91dGlscy92YWxpZGF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWVBLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxDQUMzQixLQUFZLEVBQ1osS0FBYSxFQUNiLGVBQW1ELEVBQ25ELGFBQTRDLEVBQ2pDLEVBQUU7SUFDYixJQUFJLENBQUMsZUFBZSxFQUFFLENBQUM7UUFDbkIsYUFBYSxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ3JCLE9BQU8sRUFBRSxPQUFPLEVBQUUsRUFBRSxFQUFFLENBQUM7SUFDM0IsQ0FBQztJQUVELE1BQU0sYUFBYSxHQUFHO1FBQ2xCLFVBQVUsRUFBRSxnQ0FBZ0M7UUFDNUMsWUFBWSxFQUFFLDZCQUE2QjtRQUMzQyxTQUFTLEVBQUUsNkJBQTZCO0tBQzNDLENBQUM7SUFFRixNQUFNLFdBQVcsR0FBRztRQUNoQixVQUFVLEVBQUU7WUFDUixHQUFHLEVBQUUsZUFBZSxDQUFDLFlBQVk7WUFDakMsR0FBRyxFQUFFLGVBQWUsQ0FBQyxZQUFZO1NBQ3BDO1FBQ0QsWUFBWSxFQUFFO1lBQ1YsR0FBRyxFQUFFLGVBQWUsQ0FBQyxlQUFlO1lBQ3BDLEdBQUcsRUFBRSxlQUFlLENBQUMsZUFBZTtTQUN2QztRQUNELFNBQVMsRUFBRTtZQUNQLEdBQUcsRUFBRSxlQUFlLENBQUMsa0JBQWtCO1lBQ3ZDLEdBQUcsRUFBRSxlQUFlLENBQUMsa0JBQWtCO1NBQzFDO0tBQ0osQ0FBQztJQUVGLE1BQU0sRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsV0FBVyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ3hDLE1BQU0sT0FBTyxHQUFHLGFBQWEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUVyQyxJQUFJLEtBQUssR0FBRyxHQUFHLElBQUksS0FBSyxHQUFHLEdBQUcsRUFBRSxDQUFDO1FBQzdCLGFBQWEsQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUNwQixPQUFPLEVBQUUsT0FBTyxFQUFFLENBQUM7SUFDdkIsQ0FBQztJQUVELGFBQWEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUNyQixPQUFPLEVBQUUsT0FBTyxFQUFFLEVBQUUsRUFBRSxDQUFDO0FBQzNCLENBQUMsQ0FBQyJ9